let Components = {};

Components['PlusMarkerDefault'] = require('./PlusMarkerDefault').default;
Components['PlusMarkerGiodicart'] = require('./PlusMarkerGiodicart').default;

export default Components